import { db } from "../firebase";
import { doc, getDoc, setDoc, updateDoc, collection, query, where, getDocs, serverTimestamp } from "firebase/firestore";

// 🥇 Update badge when a tip is confirmed (based on tip COUNT per artist)
export async function updateBadgeOnConfirmedTip(listenerId, artistId, artistName) {
  try {
    const badgeRef = doc(db, `users/${listenerId}/badges/${artistId}`);
    const badgeSnap = await getDoc(badgeRef);
    let tipCount = 1;

    if (badgeSnap.exists()) {
      tipCount = (badgeSnap.data().tipCount || 0) + 1;
    }

    // Determine badge level by tip count
    let badgeType = "bronze";
    let level = 1;
    if (tipCount >= 20) { badgeType = "crown"; level = 5; }
    else if (tipCount >= 10) { badgeType = "diamond"; level = 4; }
    else if (tipCount >= 5) { badgeType = "gold"; level = 3; }
    else if (tipCount >= 3) { badgeType = "silver"; level = 2; }
    const badgeTitle = `${badgeType.charAt(0).toUpperCase()}${badgeType.slice(1)} Supporter`;

    await setDoc(badgeRef, {
      artistId,
      artistName,
      tipCount,
      badgeType,
      level,
      badgeTitle,
      updatedAt: serverTimestamp()
    }, { merge: true });

    console.log(`✅ Badge updated: ${badgeType} (Level ${level}) for artist ${artistName}`);
    return { artistId, artistName, tipCount, badgeType, level, badgeTitle };
  } catch (err) {
    console.error("❌ Error updating badge:", err);
    return null;
  }
}

// 💰 Update Supporter Level by total tip amount
export async function updateSupporterLevelByAmount(listenerId) {
  try {
    const txnRef = collection(db, "transactions");
    const q = query(txnRef, where("senderId", "==", listenerId), where("status", "==", "confirmed"));
    const snap = await getDocs(q);

    let totalTips = 0;
    snap.forEach((doc) => {
      totalTips += Number(doc.data().amount || 0);
    });

    // Calculate supporter level based on total tip amount
    let supporterLevel = 0;
    if (totalTips >= 500) supporterLevel = 4;
    else if (totalTips >= 100) supporterLevel = 3;
    else if (totalTips >= 50) supporterLevel = 2;
    else if (totalTips >= 10) supporterLevel = 1;

    // Update user document with supporter level
    const userRef = doc(db, "users", listenerId);
    await updateDoc(userRef, {
      supporterLevel,
      totalTipsGiven: totalTips
    });

    console.log(`✅ Supporter level updated: Level ${supporterLevel} (Total: ₹${totalTips})`);
  } catch (err) {
    console.error("❌ Error updating supporter level:", err);
  }
}

// 🎯 Get badge for a specific listener-artist pair
export async function getBadge(listenerId, artistId) {
  try {
    const badgeRef = doc(db, `users/${listenerId}/badges/${artistId}`);
    const badgeSnap = await getDoc(badgeRef);
    return badgeSnap.exists() ? badgeSnap.data() : null;
  } catch (err) {
    console.error("❌ Error getting badge:", err);
    return null;
  }
}

// 📊 Get all badges for a listener
export async function getAllBadges(listenerId) {
  try {
    const badgesCol = collection(db, `users/${listenerId}/badges`);
    const snap = await getDocs(badgesCol);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.error("❌ Error getting all badges:", err);
    return [];
  }
}
